import React from "react";
import Tooltip from "../../../../../components/common/Tooltip/Tooltip";

/**
 * Shared preset card grid for AI feature prep tools.
 * @param {{ id: string, label: string, sub?: string, tip?: React.ReactNode }[]} presets
 */
const AiPresetCards = ({
  presets = [],
  selectedId = null,
  onSelect = () => {},
  disabled = false,
  columns = 3,
  ariaLabel = "Presets",
  boundaryRef = null,
}) => (
  <div
    className="aftp-preset-grid"
    style={{ "--aftp-preset-cols": columns }}
    role="listbox"
    aria-label={ariaLabel}
  >
    {presets.map((preset) => {
      const selected = selectedId === preset.id;
      const card = (
        <button
          type="button"
          role="option"
          aria-selected={selected}
          className={`aftp-preset-card${selected ? " is-selected" : ""}`}
          onClick={() => onSelect(preset.id)}
          disabled={disabled}
        >
          <span className="aftp-preset-card__title">{preset.label}</span>
          {preset.sub ? (
            <span className="aftp-preset-card__sub">{preset.sub}</span>
          ) : null}
        </button>
      );

      if (!preset.tip) return <React.Fragment key={preset.id}>{card}</React.Fragment>;

      return (
        <Tooltip
          key={preset.id}
          content={preset.tip}
          position="top"
          size="panel"
          block
          flip={false}
          fillBoundary={Boolean(boundaryRef)}
          boundaryRef={boundaryRef}
        >
          {card}
        </Tooltip>
      );
    })}
  </div>
);

export default AiPresetCards;
